import { GridActionsCellItem } from '@mui/x-data-grid';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useWatch } from 'react-hook-form';

import { NetZeroActionsProps } from './NetZeroActions';
import { useDisclosure } from '@hooks/useDisclosure';
import DeleteModal from '@Components/Modal/DeleteModal';
import { useGreenhouseForm } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider';

const NetZeroDeleteButton = ({ rowId }: NetZeroActionsProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, setValue } = useGreenhouseForm();

  const completedSection = useWatch({
    name: 'greenhouseGoalTerm.completedSection',
  });

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const handleDelete = () => {
    const prevNetZeros = getValues().greenhouseGoalTerm?.netZero?.details ?? [];
    const isNewDetail = typeof rowId === 'string';
    const currentIndex = isNewDetail
      ? Number(rowId.replace('NEW-', '')) - 1
      : prevNetZeros.findIndex((detail) => detail.id === rowId);

    const updateNetZeros = prevNetZeros?.filter(
      (_, index) => index !== currentIndex
    );

    setValue('greenhouseGoalTerm.netZero.details', updateNetZeros);
    close();
  };

  return (
    <>
      <GridActionsCellItem
        key="delete"
        icon={<DeleteOutlineIcon style={{ fontSize: '16px' }} />}
        label="Delete"
        onClick={open}
        disabled={isCompletedTh || isCompletedEn}
      />
      <DeleteModal
        topic="รายละเอียดการตั้งเป้าหมายการปล่อยก๊าซเรือนกระจกสุทธิเป็นศูนย์ (Net-Zero Greenhouse Gas Emissions)"
        opened={opened}
        close={close}
        confirm={handleDelete}
      />
    </>
  );
};

export default NetZeroDeleteButton;
